export const CustomersIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_111_733)">
        <path
          d="M7.81248 24.6169L8.33331 18.3669H10.9375V14.721C10.9375 13.3397 10.3887 12.0149 9.41199 11.0382C8.43524 10.0614 7.11048 9.5127 5.72915 9.5127C4.34781 9.5127 3.02305 10.0614 2.0463 11.0382C1.06955 12.0149 0.520813 13.3397 0.520813 14.721V18.3669H3.12498L3.64581 24.6169H7.81248Z"
          fill="#C4F0EB"
        />
        <path
          d="M5.72915 7.94987C7.74268 7.94987 9.37498 6.31757 9.37498 4.30404C9.37498 2.2905 7.74268 0.658203 5.72915 0.658203C3.71561 0.658203 2.08331 2.2905 2.08331 4.30404C2.08331 6.31757 3.71561 7.94987 5.72915 7.94987Z"
          fill="#C4F0EB"
        />
        <path
          d="M9.37501 4.30404C9.37645 4.66062 9.32377 5.01535 9.21876 5.35612C8.99211 4.60706 8.53044 3.95082 7.90202 3.48441C7.2736 3.018 6.51177 2.76618 5.72918 2.76618C4.94658 2.76618 4.18476 3.018 3.55633 3.48441C2.92791 3.95082 2.46624 4.60706 2.23959 5.35612C2.13458 5.01535 2.0819 4.66062 2.08334 4.30404C2.08334 3.3371 2.46746 2.40977 3.15118 1.72604C3.83491 1.04232 4.76224 0.658203 5.72918 0.658203C6.69611 0.658203 7.62344 1.04232 8.30717 1.72604C8.9909 2.40977 9.37501 3.3371 9.37501 4.30404Z"
          fill="#F8FAFC"
        />
        <path
          d="M5.72915 9.5127C4.34781 9.5127 3.02305 10.0614 2.0463 11.0382C1.06955 12.0149 0.520813 13.3397 0.520813 14.721V16.8242C0.520813 15.4428 1.06955 14.1181 2.0463 13.1413C3.02305 12.1646 4.34781 11.6158 5.72915 11.6158C7.11048 11.6158 8.43524 12.1646 9.41199 13.1413C10.3887 14.1181 10.9375 15.4428 10.9375 16.8242V14.721C10.9375 13.3397 10.3887 12.0149 9.41199 11.0382C8.43524 10.0614 7.11048 9.5127 5.72915 9.5127Z"
          fill="#F8FAFC"
        />
        <path
          d="M7.81248 24.6169L8.33331 18.3669H10.9375V14.721C10.9375 13.3397 10.3887 12.0149 9.41199 11.0382C8.43524 10.0614 7.11048 9.5127 5.72915 9.5127C4.34781 9.5127 3.02305 10.0614 2.0463 11.0382C1.06955 12.0149 0.520813 13.3397 0.520813 14.721V18.3669H3.12498L3.64581 24.6169H7.81248Z"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.72915 7.94987C7.74268 7.94987 9.37498 6.31757 9.37498 4.30404C9.37498 2.2905 7.74268 0.658203 5.72915 0.658203C3.71561 0.658203 2.08331 2.2905 2.08331 4.30404C2.08331 6.31757 3.71561 7.94987 5.72915 7.94987Z"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3667 24.6169L21.8875 18.3669H24.4917V14.721C24.4917 13.3397 23.9429 12.0149 22.9662 11.0382C21.9894 10.0614 20.6647 9.5127 19.2833 9.5127C17.902 9.5127 16.5773 10.0614 15.6005 11.0382C14.6237 12.0149 14.075 13.3397 14.075 14.721V18.3669H16.6792L17.2 24.6169H21.3667Z"
          fill="#C4F0EB"
        />
        <path
          d="M19.2833 7.94987C21.2968 7.94987 22.9291 6.31757 22.9291 4.30404C22.9291 2.2905 21.2968 0.658203 19.2833 0.658203C17.2697 0.658203 15.6375 2.2905 15.6375 4.30404C15.6375 6.31757 17.2697 7.94987 19.2833 7.94987Z"
          fill="#C4F0EB"
        />
        <path
          d="M22.9291 4.30404C22.9306 4.66062 22.8779 5.01535 22.7729 5.35612C22.5462 4.60706 22.0846 3.95082 21.4562 3.48441C20.8277 3.018 20.0659 2.76618 19.2833 2.76618C18.5007 2.76618 17.7389 3.018 17.1105 3.48441C16.482 3.95082 16.0204 4.60706 15.7937 5.35612C15.6887 5.01535 15.636 4.66062 15.6375 4.30404C15.6375 3.3371 16.0216 2.40977 16.7053 1.72604C17.389 1.04232 18.3164 0.658203 19.2833 0.658203C20.2502 0.658203 21.1776 1.04232 21.8613 1.72604C22.545 2.40977 22.9291 3.3371 22.9291 4.30404Z"
          fill="#F8FAFC"
        />
        <path
          d="M19.2833 9.5127C17.902 9.5127 16.5773 10.0614 15.6005 11.0382C14.6237 12.0149 14.075 13.3397 14.075 14.721V16.8242C14.075 15.4428 14.6237 14.1181 15.6005 13.1413C16.5773 12.1646 17.902 11.6158 19.2833 11.6158C20.6647 11.6158 21.9894 12.1646 22.9662 13.1413C23.9429 14.1181 24.4917 15.4428 24.4917 16.8242V14.721C24.4917 13.3397 23.9429 12.0149 22.9662 11.0382C21.9894 10.0614 20.6647 9.5127 19.2833 9.5127Z"
          fill="#F8FAFC"
        />
        <path
          d="M21.3667 24.6169L21.8875 18.3669H24.4917V14.721C24.4917 13.3397 23.9429 12.0149 22.9662 11.0382C21.9894 10.0614 20.6647 9.5127 19.2833 9.5127C17.902 9.5127 16.5772 10.0614 15.6005 11.0382C14.6237 12.0149 14.075 13.3397 14.075 14.721V18.3669H16.6792L17.2 24.6169H21.3667Z"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2833 7.94987C21.2968 7.94987 22.9291 6.31757 22.9291 4.30404C22.9291 2.2905 21.2968 0.658203 19.2833 0.658203C17.2697 0.658203 15.6375 2.2905 15.6375 4.30404C15.6375 6.31757 17.2697 7.94987 19.2833 7.94987Z"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_111_733">
          <rect width={25} height={25} fill="white" transform="translate(0 0.137695)" />
        </clipPath>
      </defs>
    </svg>
  );
};
